import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

import styles from './TransportsListDialog.module.sass'
import { TransportEntryWidget } from 'components/widgets'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'

// './widgets.module.sass'
import styles2 from '../../components/widgets/widgets.module.sass'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'

const TransportsListDialog = (props) => {
	const { transports, providerEntities } = props.data || {}
	const { i18n, showDialog } = useGlobal()

	console.log('transports', transports)

	return (
		<VStack className={styles['root']}>
			{transports?.length ? (
				<VStack className={styles['list']}>
					{transports.map((transport) => {
						const isApproved =
							transport.state?.toLowerCase() === 'aprovada'

						return (
							<button
								key={transport.requisitionId}
								type='button'
								className={styles['entry']}
								onClick={() =>
									showDialog(
										'TransportDetailDialog',
										i18n`Transport Requisition`,
										transport
									).catch(() => null)
								}
							>
								<HStack
									className={styles['entry-row']}
									columns={[4, 3, 4]}
									gap='small'
									align='center'
								>
									<VStack gap='xsmall' align='flex-start'>
										<span className={styles['primary']}>
											{/* {transport.medicalSpecialty} #
											{transport.requisitionId} */}
											{transport.originRequisition}
										</span>
										<span className={styles['secondary']}>
											{/* {i18n`Requested on`}{' '}
											{
												transport.createDate
													?.tinyDateFormat
											} */}
											{i18n`Requested on ${transport.createDate?.tinyDateFormat}`}
										</span>
									</VStack>

									<VStack gap='xsmall' align='flex-start'>
										<span className={styles['primary']}>
											{transport.transportDateStr}
										</span>
										<span className={styles['secondary']}>
											{transport.transportType}
										</span>
									</VStack>

									<HStack
										gap='small'
										align='center'
										justify='space-between'
									>
										<VStack gap='xsmall' align='flex-start'>
											<span className={styles['primary']}>
												{
													providerEntities?.[
														transport
															.establishmentId
													]
												}
											</span>
											<span
												className={`${
													styles['badge']
												} ${
													isApproved
														? styles['--approved']
														: styles['--rejected']
												}`}
											>
												{isApproved
													? i18n`Approved`
													: i18n`Rejected`}
											</span>
										</VStack>

										<Icon
											className={styles['chevron']}
											name='next'
											width='16px'
											height='16px'
										/>
									</HStack>
								</HStack>
							</button>
						)
					})}
				</VStack>
			) : (
				<small>{i18n`There are no transports.`}</small>
			)}
		</VStack>
	)
}

export default TransportsListDialog
